// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"49b9632d","326":"a4bd1f97","671":"ff656fd3","744":"61f57fac","787":"0b711b59","997":"825552d3"}[chunkId] + ".chunk.js";
};